__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/95cd83a/_next/";